import http from '@utils/http';

export default {
  // 查询SQL审批单
  orderSelect: data => http.post('/teslaApi/wx-open/order-select', data),

  // 初审通过
  firstPass: data => http.post('/teslaApi/wx-open/first/pass', data),

  // 初审/复审 驳回
  refuse: data => http.post('/teslaApi/wx-open/refuse', data),

  // 初审/复审 订单撤销
  undo: data => http.post('/teslaApi/wx-open/undo', data),
};